module.exports = __webpack_public_path__ + "img/green.0a6db094.jpg";